/* Brand-neutral parallax sticky-stack — open/close + scroll-driven scale.
   Event-delegated; one observer per section root; customizer-aware.

   Note: this script used to walk the DOM on init and force
   `overflow: visible !important` on any ancestor that had overflow:hidden,
   because `position: sticky` collapses inside a clipped scroll container.
   That mutation persisted across re-renders, was invisible to the
   Customizer, and risked stomping on theme-author CSS. The clipping
   ancestor is now handled declaratively in CSS: `.sb-main` (the only
   realistic ancestor candidate on blog templates) sets `overflow: visible`
   in assets/blog-tokens.css. If a different ancestor ever clips, fix it
   in the stylesheet, not here. */
(function() {
  'use strict';

  function init(root) {
    if (!root || root.dataset.bpsInited === '1') return;
    root.dataset.bpsInited = '1';

    var toggle = root.querySelector('[data-blog-parallax-stack-toggle]');
    var viewport = root.querySelector('[data-blog-parallax-stack-viewport]');
    if (!viewport) return;

    var openLabel = root.querySelector('[data-toggle-label-open]');
    var closeLabel = root.querySelector('[data-toggle-label-close]');

    if (toggle) {
      toggle.addEventListener('click', function() {
        var willOpen = !root.classList.contains('blog-parallax-stack--open');
        root.classList.toggle('blog-parallax-stack--open', willOpen);
        toggle.setAttribute('aria-expanded', String(willOpen));
        if (openLabel)  openLabel.hidden  = willOpen;
        if (closeLabel) closeLabel.hidden = !willOpen;
      });
    }

    /* Scroll-driven scale: the active (frontmost stuck) card grows from
       0.95 → 1 as the previous card leaves; cards behind it sit
       progressively smaller. Pure transform; no layout thrash. */
    var ticking = false;
    var slides = root.querySelectorAll('.blog-parallax-stack__slide');
    if (slides.length === 0) return;

    var peek = parseFloat(getComputedStyle(root).getPropertyValue('--bps-peek')) || 80;

    function onScroll() {
      var vh = window.innerHeight;
      var stickY = vh - peek;

      var states = [];
      slides.forEach(function(slide) {
        var rect = slide.getBoundingClientRect();
        states.push({ rect: rect, away: rect.bottom < stickY - 5 });
      });

      var activeIndex = -1;
      for (var k = 0; k < states.length; k++) {
        if (!states[k].away) { activeIndex = k; break; }
      }

      var leaveProgress = 0;
      if (activeIndex > 0) {
        var leavingRect = states[activeIndex - 1].rect;
        leaveProgress = Math.max(0, Math.min(1, 1 - leavingRect.bottom / stickY));
      }

      slides.forEach(function(slide, i) {
        var st = states[i];
        if (st.away) {
          slide.style.transform = '';
        } else if (i === activeIndex) {
          if (activeIndex === 0 || leaveProgress >= 0.95) {
            slide.style.transform = '';
          } else {
            var growScale = 0.95 + (leaveProgress * 0.05);
            var growTy = 20 - (leaveProgress * 20);
            slide.style.transform = 'scale(' + growScale.toFixed(3) + ') translateY(' + growTy.toFixed(1) + 'px)';
          }
        } else if (activeIndex >= 0 && i > activeIndex) {
          var behind = i - activeIndex;
          var baseScale = 1 - (behind * 0.05);
          var baseTy = behind * 20;
          if (behind === 1 && leaveProgress > 0) {
            baseScale += leaveProgress * 0.05 * 0.5;
            baseTy   -= leaveProgress * 20 * 0.5;
          }
          slide.style.transform = 'scale(' + baseScale.toFixed(3) + ') translateY(' + baseTy.toFixed(1) + 'px)';
        } else {
          slide.style.transform = '';
        }
      });

      ticking = false;
    }

    window.addEventListener('scroll', function() {
      if (!ticking) { requestAnimationFrame(onScroll); ticking = true; }
    }, { passive: true });

    /* Run once on init so the initial paint is correct */
    requestAnimationFrame(onScroll);
  }

  function initAll() {
    document.querySelectorAll('[data-blog-parallax-stack]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function(e) {
    var root = e.target.querySelector('[data-blog-parallax-stack]');
    if (root) {
      delete root.dataset.bpsInited;
      init(root);
    }
  });
})();
